"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard")["default"];
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/objectSpread2"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _clsx8 = _interopRequireDefault(require("clsx"));
var _context = _interopRequireDefault(require("../Theme/context"));
var _excluded = ["classNames", "label", "children", "className", "variant", "disabled", "gutterBottom", "bolder", "lighter", "weight", "fontSize", "letterSpacing", "lineHeight", "variantMapping"],
  _excluded2 = ["Component"];
var defaultStyle = require("./../empty_css.js")["default"];
var _default = exports["default"] = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var _useContext = (0, _react.useContext)(_context["default"]),
    componentsStyle = _useContext.componentsStyle,
    useStyle = _useContext.useStyle;
  var _props$classNames = props.classNames,
    classNames = _props$classNames === void 0 ? componentsStyle || defaultStyle : _props$classNames,
    _props$label = props.label,
    label = _props$label === void 0 ? '' : _props$label,
    _props$children = props.children,
    children = _props$children === void 0 ? null : _props$children,
    _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className,
    _props$variant = props.variant,
    variant = _props$variant === void 0 ? 'body' : _props$variant,
    _props$disabled = props.disabled,
    disabled = _props$disabled === void 0 ? false : _props$disabled,
    _props$gutterBottom = props.gutterBottom,
    gutterBottom = _props$gutterBottom === void 0 ? false : _props$gutterBottom,
    _props$bolder = props.bolder,
    bolder = _props$bolder === void 0 ? false : _props$bolder,
    _props$lighter = props.lighter,
    lighter = _props$lighter === void 0 ? false : _props$lighter,
    _props$weight = props.weight,
    weight = _props$weight === void 0 ? 0 : _props$weight,
    fontSize = props.fontSize,
    letterSpacing = props.letterSpacing,
    lineHeight = props.lineHeight,
    _props$variantMapping = props.variantMapping,
    variantMapping = _props$variantMapping === void 0 ? {
      h1: 'h1',
      h2: 'h2',
      h3: 'h3',
      h4: 'h4',
      h5: 'h5',
      h6: 'h6',
      subtitle1: 'h6',
      subtitle2: 'h6',
      body: 'p',
      'button-large': 'div',
      'button-default': 'div',
      'button-small': 'div',
      'button-inline': 'span',
      'label1': 'div',
      'label2': 'div'
    } : _props$variantMapping,
    rest2 = (0, _objectWithoutProperties2["default"])(props, _excluded);
  var _rest2$Component = rest2.Component,
    Component = _rest2$Component === void 0 ? variant && variantMapping[variant] ? variantMapping[variant] : 'div' : _rest2$Component,
    rest = (0, _objectWithoutProperties2["default"])(rest2, _excluded2);
  if (classNames !== componentsStyle) {
    if (typeof useStyle === 'function') {
      useStyle(classNames);
    }
  }
  return /*#__PURE__*/_react["default"].createElement(Component, Object.assign({}, rest, {
    ref: ref,
    className: (0, _clsx8["default"])(classNames.typography, (0, _defineProperty2["default"])({}, classNames['typography-' + variant], variant && classNames['typography-' + variant]), (0, _defineProperty2["default"])({}, classNames['typography-disabled'], disabled && classNames['typography-disabled']), (0, _defineProperty2["default"])({}, classNames.gutterBottom, gutterBottom), (0, _defineProperty2["default"])({}, classNames.typographyBolder, bolder), (0, _defineProperty2["default"])({}, classNames.typographyLighter, lighter), (0, _defineProperty2["default"])({}, classNames['typographyWeight' + weight], weight && classNames['typographyWeight' + weight]), (0, _defineProperty2["default"])({}, className, className)),
    style: (0, _objectSpread2["default"])((0, _objectSpread2["default"])((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, typeof fontSize === 'string' || typeof fontSize === 'number' ? {
      '--octopwn-typography-font-size': fontSize
    } : {}), letterSpacing ? {
      letterSpacing: letterSpacing
    } : {}), lineHeight ? {
      lineHeight: lineHeight
    } : {}), rest.style ? rest.style : {})
  }), children || label);
});